module.exports = __webpack_public_path__ + "img/zhiou.feec9ab7.png";